import Box from "@mui/material/Box";
import React from "react";
import GenieText from "../../../components/core/genie-text/GenieText";
import GeniePage from "../../../components/special/genie-page/GeniePage";
import Shipping from "./shipping/Shipping";
import { useParams } from "react-router-dom";

function Checkout() {
  const { org_id } = useParams();
  return (
    <GeniePage>
      <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <GenieText header>Checkout</GenieText>
        <GenieText
          link={`/storefront/${org_id}`}
          style={{ cursor: "pointer" }}
          fontSize={"tiny"}
          underline
        >
          Back to store
        </GenieText>
      </Box>
      <Shipping />
    </GeniePage>
  );
}

export default Checkout;
